export default {
  receipttrack: {
    searchPlaceholder: '请输入商品名或收货单号或供应商进行搜索',
    receiptNo: 'srm收货单号',
    docDate: '收货日期',
    purOfficeName: '采购中心',
    sourceNo: '来源单号',
    supplierName: '供应商',
    receiptSeq: '项次',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    receiptQty: '收货数量',
    purUnitName: '单位',
    purchaseNo: '订单单号',
    purchaseSeq: '订单项次',
    purchasePhaseSeq: '订单项序',
    supLotNo: '供应商批号',
    supDeliveryQty: '供应商送货数量',
    status: '状态',
    outReceiptNo: 'erp收货单号',
    expectArrivalDate: '预计交货日期',
    expectedArrivalDate: '预计到货日',
    purchaseUnitNo: '采购中心',
    docDateStart: '收货日期-起',
    docDateEnd: '收货日期-止',
    dateRange: '收货日期',
    statusY: '审核',
    statusV: '作废',
    allNames: '项次-项序-分批序'
  },
  deliverytrack: {
    searchPlaceholder: '输入商品名或发货单号或供应商进行搜索',
    deliveryNo: '发货单号',
    status: '状态',
    deliveryDate: '发货日期',
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    deliverySeq: '项次',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    sumDeliveryQty: '发货量',
    sumReceiveQty: '收货量',
    receiving: '收货',
    returnReceiving: '取消收货',
    closed: '结案',
    headInfo: '基础信息',
    supplierInfo: '供应商资料',
    billInfo: '单据资料',
    otherInfo: '其他信息',
    deliveryAddress: '地址',
    deliverer: '供应商联络人',
    deliveryMobile: '联系方式',
    expectArrivalDate: '预计到货日期',
    orderTypeStr: '订单性质',
    receiveWare: '送达仓库',
    receiver: '收货人',
    goOpenBill: '去开票',
    receiveMobile: '联系方式',
    receiveTime: '收货时段',
    remarks: '备注',
    deliveryDetail: '发货单明细',
    purchaseNo: '订单单号',
    purchaseSeq: '项次-顺序',
    purchaseQty: '订单量',
    undeliveredQty: '可发货量',
    unReceiveQty: '未交量',
    deliveryQty: '发货量',
    receiveQty: '收货量',
    overQty: '超交量',
    expectedArrivalDate: '预计交货日期',
    purchaseUnitNo: '采购中心',
    startDeliveryDate: ' 发货日期-起',
    endDeliveryDate: '发货日期-止',
    supOfficeNo: '供应商编号',
    receivingTitle: '收货详情',
    curSumReceiveQty: '本次收货总量',
    purchasePhaseSeq: '项序',
    purchaseQtyAndpurchaseReceiveQty: '订单量 / 订单收货量',
    receiptQty: '收货量',
    dSumDeliveryQty: '发货总量',
    dSumReceiveQty: '已收货总量',
    dReceiveQty: '已收货量',
    returnReceivingTitle: '收货单号',
    receiptNo: '收货单号',
    outReceiptNo: '外部收货单号',
    docDate: '收货日期',
    needSelection: '请选择一笔数据',
    closedTitle: '结案发货单身',
    checkStatus1: '已发货',
    checkStatus2: '部分收货',
    checkStatus3: '已收货',
    checkStatus4: '已作废'
  }
}
